import request from '@/service/request'

export const getOrderPage = (params: API.Params & {category: ENUM.CATEGORY}) => {
  return request<SERVICE.ResponsePage<HOME.ORDER[]>>({
    url: '/admin/mp-order/page',
    method: 'GET',
    params
  })
}

export const getOrderById = (id: string) => {
  return request<SERVICE.Response<HOME.ORDER>>({
    url: `/admin/mp-order/${id}`,
    method: 'GET'
  })
}

export const getCountRefund = () => {
  return request<SERVICE.Response<HOME.ORDER>>({
    url: '/admin/mp-order/countRefund',
    method: 'GET'
  })
}

export const refund = (data: {
  'orderId': string,
  'refundAmount': number,
  'refundReason': string
}) => {
  return request<SERVICE.Response<HOME.ORDER>>({
    url: '/admin/mp-order-pay/refund',
    method: 'POST',
    data
  })
}
